import React, { Component } from 'react'
import { connect } from 'react-redux'
import { changePage, 
    getItemList, 
    defaultStoreItemList, 
    selectedNavComponent, 
    selectedFood, 
    selectedSubItem, 
    setTotalOrderPrice,
    setHCommerceSavedOrders, 
    setSelectedSubTypeSubMenuList, 
    setSelectedSubItemList,
    setSelectedSubItemListStoreLevel2,
    setSelectedSubItemStoreLevel2 } from '../../../action/hcommerce'
import { CMSPath } from '../../../config/constant'
import { hCommColor } from '../../JS/colorConfig'
import { dynamicHeight } from '../../JS/listItemHeightFix';
import { totalPriceCal } from '../../JS/totalPriceCal'
import { closeOrderPopUp } from '../../action/hCommerce2'
import AddOnPopup from './addOnPopup/addOnPopup';
import $ from 'jquery'
import { addToMyOrder } from './itemActions';
import Loader from '../../UI/loader';
import {withTranslation} from 'react-i18next'
import SuccessFailScreen from '../../UI/SuccessFailScreen'
import axios from  'axios'
import { extractIdsOfStoreData, extractIdsOfSubtypeData, getCleanUrl, getDefaultAnalyticsLabel } from '../../JS/utility'
import { sendAnalytics } from '../../../action/homeAction'
import { getCdnUrl } from '../../../config/config'

class StoreLevel2 extends Component {

    constructor(props){
        super(props);
        this.state = {
            quantity:1,
            addOn:[],
            showAddOn:false,
            itemsHaveAddonsList: [],
            showLoader:true,
            getItemListAPICallCount: 0,
            showFailscreen: false,
            selectedSubtype: null
        }
        this.selected = null;
        this.timeRef = null;
    }

    componentDidMount() {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        if(localStorage.getItem("storeLevel2EventSent") !== "true"){
            // Send Analytics
                let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
                this.props.sendAnalytics(
                    this.props.guestDetail, 
                    this.props.currentWidgets.widgetType, 
                    "STORE LEVEL - 2", 
                    {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), pageName: "STORE LEVEL - 2", storeName: this.props.storeInfo.storeName}, 
                    0, 
                    this.props.guestIsLoggedIn,
                    () => localStorage.setItem("storeLevel2EventSent", true)
                );
            //
        }

        if(localStorage.getItem("storeLevel3EventSent") !== "true" && this.props.subItemListStoreLevel2.length > 0){
            // Send Analytics
                let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
                this.props.sendAnalytics(
                    this.props.guestDetail, 
                    this.props.currentWidgets.widgetType, 
                    "STORE LEVEL - 3", 
                    {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), pageName: "STORE LEVEL - 3", storeName: this.props.storeInfo.storeName}, 
                    0, 
                    this.props.guestIsLoggedIn,
                    () => localStorage.setItem("storeLevel3EventSent", true)
                );
            //
        }

        if (this.props.SelectedSubItem && this.props.SelectedSubItem.id) {
            // this.timeRef = setInterval(() => {
            //     this.setState({getItemListAPICallCount : this.state.getItemListAPICallCount + 1})
            //     this.props.getItemList(this.props.guestDetail, this.props.SelectedSubItem.id, (status) => {
            //         if(status){
            //             this.setState({showLoader:false})
            //             clearInterval(this.timeRef)
            //             this.setState({getItemListAPICallCount : 0})
            //             source.cancel()
            //         }
            //     }, source);
            // }, 2000)
            if(this.props.subTypeSubTypeMapping){
                console.log("subsubtype",extractIdsOfSubtypeData(this.props.SelectedSubItem.id, this.props.subTypeSubTypeMapping, 'storeItemSubTypeChildId', 'storeItemSubTypeParentId'))
                this.props.setSelectedSubTypeSubMenuList(extractIdsOfSubtypeData(this.props.SelectedSubItem.id, this.props.subTypeSubTypeMapping, 'storeItemSubTypeChildId', 'storeItemSubTypeParentId'))
            }
            let itemsHaveAddonsList = []
            for(let i=0; i<this.props.itemAddOnsInfo.length; i++) if(!itemsHaveAddonsList.includes(this.props.itemAddOnsInfo[i]['storeItemId'])) itemsHaveAddonsList.push(this.props.itemAddOnsInfo[i]['storeItemId'])

            this.setState({itemsHaveAddonsList:  itemsHaveAddonsList})


        }
        hCommColor(this.props.menuColor);
        dynamicHeight();
        // setTimeout(()=> this.setState({getItemListAPICallCount: 3}), 5000 )
        // $("#store_level2_widgets").attr("style","margin-bottom:7rem !important;")
        // console.log("store level 2 margin bottom",$("#store_level2_widgets").css("margin-bottom"));
    }

    componentWillUnmount() {
        // this.props.defaultStoreItemList([])
    }
    componentDidUpdate(prevProps,prevState) {
        hCommColor(this.props.menuColor);
        dynamicHeight();

        if(this.state.showAddOn !== prevState.showAddOn){
            if(this.state.showAddOn){
                $("body").addClass("overlay-cast");
            }else{
                $("body").removeClass("overlay-cast");
            }
        }

        if( prevState.getItemListAPICallCount !== this.state.getItemListAPICallCount && this.state.getItemListAPICallCount > 3){
            clearInterval(this.timeRef)
            this.setState({
                showLoader: false,
                getItemListAPICallCount: 0,
                showFailscreen: true
            })
        }
    }
    goBack = () => {

        if(this.state.showAddOn){
            this.setState({showAddOn: false})
            return;
        }


        if(this.state.showAddOn){
            this.setState({showAddOn: false})
            return;
        }

        this.props.changePage("StoreLevel1");
    }

    goToItemInfo = (nextPage, selecteditem) => {


        this.props.selectedFood(selecteditem);

        // for newer flow "addons with grouping", if store item has addon then we directly show AddOns list instead of itemInfo.
        if( this.props.addOnGroupTypeInfo.length > 0 && this.state.itemsHaveAddonsList.includes(selecteditem.id)) {
            this.selected = selecteditem;
            this.setState({showAddOn:true})
        } else {
            this.props.changePage(nextPage);
        }
    }

    tryAgain = () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (this.props.SelectedSubItem && this.props.SelectedSubItem.id) {
            this.setState({
                showLoader: true,
                getItemListAPICallCount: 0,
                showFailscreen: false
            })
            this.timeRef = setInterval(() => {
                this.setState({getItemListAPICallCount : this.state.getItemListAPICallCount + 1})
                this.props.getItemList(this.props.guestDetail, this.props.SelectedSubItem.id, (status) => {
                    if(status){
                        this.setState({showLoader:false})
                        clearInterval(this.timeRef)
                        this.setState({getItemListAPICallCount : 0})
                        source.cancel()
                    }
                }, source);
            }, 30000)
        }
    }

    openSubSubTypeItmes = (subItem) => {
        this.props.setSelectedSubItemListStoreLevel2(extractIdsOfStoreData(subItem.id, this.props.storeItemStoreItemSubTypeInfo, 'storeItem', 'storeItemSubType'))
        this.setState({selectedSubtype: subItem})
        this.props.setSelectedSubItemStoreLevel2(subItem)
    }

    addOnCheckBoxCLick = (addOns, callback) => {
        this.setState({ addOn: addOns }, () => callback(true));
    }

    addToMyOrderCallback = () => {
        this.setState({showAddOn:false});
        this.setState({addOn:[]});
    }


    render() {
        let imagePath;
        const {t} = this.props
        const add_to_cart = t('hcommerce.storelevel1.added_to_cart')
        return (
            <div>
                <header class="inner-pages subpages" style={{zIndex:"999"}}>
                    <a class="button-back" onClick={this.props.subItemListStoreLevel2.length > 0 ? () => {
                                                                                                        this.props.setSelectedSubItemListStoreLevel2([])
                                                                                                        this.props.setSelectedSubItemStoreLevel2(null)
                                                                                                    } : this.goBack}></a>
                    <div class="heading align-center">
                        {/* <p class="bold" style = {{color:"inherit"}}>{this.props.selectedSubItemStoreLevel2 ? this.props.selectedSubItemStoreLevel2.subTypeName : this.props.SelectedSubItem.subTypeName}</p> */}
                        <div class="splash-brand">
                            <img src={getCdnUrl(CMSPath, this.props.logo)} />
                        </div>
                    </div>
                </header>
                <section class="widgets" id = "store_level2_widgets">

                    <div class="widget-header">
                        { this.props.currentWidgets.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgets.widgetHeaderImageUrl}`} alt={this.props.currentWidgets.displayName} />
                            </div>
                        }
                        <div class="widget-header-title" dangerouslySetInnerHTML={{__html: this.props.selectedSubItemStoreLevel2 ? this.props.selectedSubItemStoreLevel2.subTypeName : this.props.SelectedSubItem.subTypeName}} ></div>
                    </div>

                    <div class="widgets">
                        <div class="row margin-bottom-2">
                            <div class="row">
                                <div class="col col-2 menu-items">
                                    {console.log("this.props.storeItemList",this.props.storeItemList)}

                                    {
                                        this.props.itemSubTypeList.length > 0 && this.props.subItemListStoreLevel2.length == 0 ?
                                            this.props.itemSubTypeList.map((iterator) => {
                                                imagePath=null;
                                                if (iterator.storeItemTypeImages && iterator.storeItemTypeImages.length === 1) {
                                                    
                                                    imagePath = getCleanUrl(`${iterator.storeItemTypeImages[0].imagePath}`)
                                                } else {
                                                    iterator.storeItemTypeImages && iterator.storeItemTypeImages.map((images) => {
                                                        if (images.imageType === "LARGE") {
                                                            imagePath = encodeURI(getCleanUrl(`${CMSPath}${images.imagePath}`))
        
                                                        }
                                                    })
                                                }
                                                return this.props.selectedSubtypeSubMenuList.includes(iterator.id) && (
                                                    <a class="tile-sm thumbnails tile-container"
                                                        onClick={() => { this.openSubSubTypeItmes(iterator) }}
                                                    >
                                                        <img src={imagePath}  />

                                                        <div class="thumb-text">
                                                            <p class="thumb-heading" dangerouslySetInnerHTML={{__html: `${iterator.subTypeName}`}}></p>
                                                            {/* <p>Some description here</p> */}
                                                            <p class="addon-button">
                                                                <span class="addon-price">{t('hcommerce.storelevel1.open')}</span>
                                                                <span class="addon-icon">
                                                                    <i class="fas fa-list"></i>
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </a>
                                                )
                                            })
                                            : null
                                    }

                                    {
                                        this.props.storeItemList.map((iterator) => {
                                            imagePath=null;
                                            if (iterator.storeItemImages.length === 1) {
                                                imagePath = getCleanUrl(`${iterator.storeItemImages[0].imagePath}`)
                                            } else {
                                                iterator.storeItemImages.map((images) => {
                                                    if (images.imageType === "LARGE") {
                                                        imagePath = encodeURI(getCleanUrl(`${images.imagePath}`));
                                                        if (imagePath.indexOf('(') !== -1) {
                                                            imagePath = imagePath.replace("(", "%28");
                                                        }
                                                        if (imagePath.indexOf(')') !== -1) {
                                                            imagePath = imagePath.replace(")", "%29");
                                                        }
                                                        //console.log("imagePath", imagePath);
                                                    }
                                                })
                                            }
                                            // if (iterator.storeItemImages.length === 0) {
                                            //     imagePath = //`${CMSPath}/../cmsData/hCommerce/defaultImages/default.png `
                                            //     defaultImage
                                            // }
                                            if(this.props.subItemListStoreLevel2.length == 0){
                                                return this.props.subItemList.includes(iterator.id) && (
                                                <a class="tile-sm thumbnails tile-container" >
                                                <img src={imagePath}  onClick={() => { this.goToItemInfo("itemInfo", iterator) }}/>
                                                <div class="thumb-text" >
                                                    <p class="thumb-heading"  onClick={() => { this.goToItemInfo("itemInfo", iterator) }} dangerouslySetInnerHTML={{__html: iterator.itemName}}></p>
                                                    <p class="addon-button" onClick={() => {
                                                                if(!this.props.storeInfo.disableAddRemoveItemsButtons){
                                                                    this.props.selectedFood(iterator);
                                                                    this.selected = iterator;
                                                                    this.state.itemsHaveAddonsList.includes(iterator.id) ? 
                                                                    this.setState({showAddOn:true}) : addToMyOrder(iterator,this.state,this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp,this.addToMyOrderCallback, `${add_to_cart}`)
                                                                }
                                                            }}>
                                                        <span class="addon-price" dangerouslySetInnerHTML={{__html: `${this.props.currencyCode} ${iterator.itemPrice}`}}></span>
                                                        { !this.props.storeInfo.disableAddRemoveItemsButtons && <span class="addon-icon" style = {{flex:"0"}}>
                                                            <i class="fas fa-plus"></i>
                                                        </span>}
                                                    </p>
                                                </div>
                                            </a>
                                               
                                            )}
                                            else{
                                            return this.props.subItemListStoreLevel2.includes(iterator.id) && (
                                                <a class="tile-sm thumbnails tile-container" >
                                                <img src={imagePath}  onClick={() => { this.goToItemInfo("itemInfo", iterator) }}/>
                                                <div class="thumb-text" >
                                                    <p class="thumb-heading"  onClick={() => { this.goToItemInfo("itemInfo", iterator) }} dangerouslySetInnerHTML={{__html: `${iterator.itemName}`}}></p>
                                                    <p class="addon-button" onClick={() => {
                                                                if(!this.props.storeInfo.disableAddRemoveItemsButtons){
                                                                    this.props.selectedFood(iterator);
                                                                    this.selected = iterator;
                                                                    this.state.itemsHaveAddonsList.includes(iterator.id) ? 
                                                                    this.setState({showAddOn:true}) : addToMyOrder(iterator,this.state,this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp,this.addToMyOrderCallback, `${add_to_cart}`)
                                                                }
                                                            }}>
                                                        <span class="addon-price" dangerouslySetInnerHTML={{__html: `${this.props.currencyCode} ${iterator.itemPrice}`}}></span>
                                                        { !this.props.storeInfo.disableAddRemoveItemsButtons && <span class="addon-icon" style = {{flex:"0"}}>
                                                            <i class="fas fa-plus"></i>
                                                        </span>}
                                                    </p>
                                                </div>
                                            </a>
                                               
                                            )
                                        }})
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    this.state.showFailscreen &&  <SuccessFailScreen showTryAgain={true} showClose={true} status={false} statusMessage1="We are unable to process the request at this moment." close={() => this.goBack()} tryAgain={this.tryAgain} />
                }
                {
                    this.state.showAddOn && <AddOnPopup pageName={this.props.subItemListStoreLevel2.length > 0 ? "STORE LEVEL - 3" : "STORE LEVEL - 2"} addOn = {this.state.addOn} backBtn = {() => this.setState({showAddOn:false})}
                    addOnCheckBoxCLick = {this.addOnCheckBoxCLick} addToMyOrder = {() => addToMyOrder(this.selected,this.state,this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp,this.addToMyOrderCallback, `${add_to_cart}`)}/>
                }
                {/* {this.state.showLoader && <Loader/>} */}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        SelectedSubItem: state.store.Hcommerce.SelectedSubItem,
        storeItemList: state.store.Hcommerce.storeItemList,
        menuColor: state.store.home.MenuColor,
        subItemList: state.store.Hcommerce.subItemList,
        addOnGroupTypeInfo: state.store.Hcommerce.addOnGroupTypeInfo,
        subItemListStoreLevel2: state.store.Hcommerce.subItemListStoreLevel2,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        SelectedFood: state.store.Hcommerce.SelectedFood,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        itemAddOnsInfo: state.store.Hcommerce.itemAddOnsInfo,
        storeInfo: state.store.Hcommerce.storeInfo,
        subTypeSubTypeMapping: state.store.Hcommerce.subTypeSubTypeMapping,
        itemSubTypeList: state.store.Hcommerce.itemSubTypeList,
        selectedStoreSubMenuList: state.store.Hcommerce.selectedStoreSubMenuList,
        selectedSubtypeSubMenuList: state.store.Hcommerce.selectedSubtypeSubMenuList,
        storeItemStoreItemSubTypeInfo: state.store.Hcommerce.storeItemStoreItemSubTypeInfo,
        selectedSubItemStoreLevel2: state.store.Hcommerce.selectedSubItemStoreLevel2,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
    }
}
export default connect(
    mapStateToProps,
    {
        changePage,
        getItemList,
        defaultStoreItemList,
        selectedFood,
        closeOrderPopUp,
        setTotalOrderPrice,
        setHCommerceSavedOrders,
        setSelectedSubTypeSubMenuList,
        setSelectedSubItemList,
        selectedSubItem,
        selectedNavComponent,
        setSelectedSubItemListStoreLevel2,
        setSelectedSubItemStoreLevel2,
        sendAnalytics
    }
)(withTranslation('translations')(StoreLevel2));